import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-[#121212] text-[#F5F2EA] pt-24 pb-10 grain overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
        <div className="md:col-span-5">
          <Logo color="#D9BE86" size="text-3xl" />
          <p className="font-serif text-2xl font-light leading-snug mt-8 max-w-sm text-[#F5F2EA]/85">
            Handcrafted stories, worn with grace.
          </p>
          <Link
            to="/custom-orders"
            data-testid="footer-custom-cta"
            className="inline-flex items-center gap-2 mt-8 overline text-[#D9BE86] link-underline"
          >
            Begin a custom order <ArrowUpRight size={16} strokeWidth={1.5} />
          </Link>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-white/40 mb-6">Explore</p>
          <ul className="space-y-3 font-serif text-xl font-light">
            {[
              ["Home", "/"],
              ["About", "/about"],
              ["Collections", "/collections"],
              ["Custom Orders", "/custom-orders"],
              ["Queries", "/queries"],
              ["Contact", "/contact"],
            ].map(([l, to]) => (
              <li key={to}>
                <Link to={to} className="text-[#F5F2EA]/80 hover:text-[#D9BE86] transition-colors">
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline text-white/40 mb-6">Get in touch</p>
          <ul className="space-y-4 text-[#F5F2EA]/80">
            <li className="flex items-center gap-3">
              <Mail size={16} strokeWidth={1.5} className="text-[#D9BE86]" />
              <a href="mailto:hello@arkaari.com" className="link-underline">care@arkaari.com</a>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} strokeWidth={1.5} className="text-[#D9BE86]" />
              <a href="tel:+910000000000" className="link-underline">+91 87700 80794</a>
            </li>
            <li className="flex items-center gap-3">
              <Instagram size={16} strokeWidth={1.5} className="text-[#D9BE86]" />
              <a href="https://www.instagram.com/houseofarkaari?igsh=MW0zZDAxYm41ZW1qbg%3D%3D&utm_source=qr" target="_blank" rel="noreferrer" className="link-underline">@arkaari</a>
            </li>
          </ul>
          <p className="text-white/35 text-xs mt-6 leading-relaxed">
            Atelier by appointment.<br />Contact details are placeholders — share yours to update.
          </p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-white/40 text-xs">
        <p>© {new Date().getFullYear()} Arkaari — by Ankita Mangtani. All rights reserved.</p>
        <p className="overline text-white/30">Timeless · Handcrafted · Elegant · Indian · Modern</p>
      </div>
    </div>
  </footer>
);
